import { z } from 'zod';

const CertificateItemSchema = z.object({
  id_office: z.number().int(),
  number: z.string(),
  isAvailable: z.boolean().optional(),
  message: z.string().optional(),
  id_product: z.number().int(),
  pre_consultation: z.number().int().optional(),
});

const RedeemCodeSchema = z.object({
  value_redeem_code: z.string(),
  amount_pay: z.number(),
});

export const PaymentRequestSchema = z.object({
  request: z.object({
    type_product: z.number().int(),
    document_type: z.string(),
    document_number: z.string(),
    email: z.string().email(),
    phone: z.string(),
    fullname: z.string(),
    address: z.string().optional(),
    payment_method: z.string(),
    bank: z.string().optional(),
    source: z.string().optional(),
    person_type: z.string().optional(),
    total_amount: z.number(),
    certificates: z.array(CertificateItemSchema),
    promo_email_permission: z.boolean().optional(),
    redeem_codes: z.union([z.array(RedeemCodeSchema), z.string()]).optional(),
    card_name: z.string().optional(),
    card_number: z.string().optional(),
    card_year: z.string().optional(),
    card_month: z.string().optional(),
    card_cvv: z.string().optional(),
    installments: z.string().optional(),
  })
});

export const PaymentResponseSchema = z.object({
  data: z.object({
    pseURL: z.string().optional(),
    transactionId: z.string().optional(),
    id_request: z.string().optional(),
  }).optional(),
  transaction_id: z.string().optional(),
  transactionId: z.string().optional(),
  ok: z.boolean().optional(),
  message: z.string().optional(),
}).passthrough();


export const RedeemCodesRequestSchema = z.object({
  request: z.object({
    type_product: z.coerce.number().int().default(1),
    source: z.string().optional(),
    type_transaction: z.string().optional(),
    certificate_type_id: z.coerce.number().int().optional(),
    document_type: z.string(),
    document_number: z.string(),
    email: z.string().email(),
    phone: z.string(),
    fullname: z.string(),
    payment_method: z.string(),
    total_amount: z.coerce.number(),
    total_wompi: z.coerce.number().optional(),
    certificates: z.array(
      z.object({
        id_office: z.coerce.number().int(),
        office_value: z.string().optional(),
        number: z.string(),
        id_product: z.coerce.number().int().default(1),
        address: z.string().optional(),
        isAvailable: z.boolean().optional(),
        message: z.string().optional(),
      })
    ),
    promo_email_permission: z.boolean().optional(),
    redeem_codes: z.array(
      z.object({
        value_redeem_code: z.string(),
        amount_pay: z.coerce.number(),
      })
    ),
  })
});

export type PaymentRequest = z.infer<typeof PaymentRequestSchema>;
export type PaymentResponse = z.infer<typeof PaymentResponseSchema>;
export type RedeemCodesRequest = z.infer<typeof RedeemCodesRequestSchema>;

